<template>
<div id="millestones">

      <div class="container">

        <div class="row">
          <div class="col-md-12">
            <div class="title">
              Encontre um projeto que toca seu coração e <span>ajude como puder</span>
            </div>
          </div>

          <div class="col-md-12">
            <div class="projects row">

              <div class="col-md-3" v-for="c in categories" v-bind:key="c.CategoryId" v-if="c.isFeatured">
                <div class="item" v-on:click="openCategory(c.url)">
                  <div class="image">
                    <img :src="c.imageSquare" />
                  </div>
                  <div class="content">
                    <h5>{{c.name}}</h5>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
</template>

<script>
export default {
  props: ['categories'],
  data(){
    return {
      
    }
  },
  methods: {
    openCategory(slug){
      this.$router.push('/projects/' + slug);
    }
  }
}
</script>

<style scoped lang="scss">
#millestones{
  background-color: #f4f4f4;
  min-height: 350px;
  padding-top: 20px;
  padding-bottom: 60px;

  .title{
    margin-top: 40px;
    font-size: 28px;
    font-family: RalewayRegular;

    span{
      color: #00AE39;
    }
  }

  .projects{

    .item{
      background-color: #fff;
      margin-top: 20px;
      font-family: RalewayRegular;
      cursor: pointer;

      &:hover{
        box-shadow: 0px 1px 20px #888888;
      }

      .image{
        width: 100%;
        overflow: hidden;

        img{
          width: 100%;
        }
      }

      .content{
        margin-top: 10px;
        padding: 5px;
        text-align: center;
        h5{
          font-size: 18px;
          font-family: RalewayBold;
        }

        .tags{
          padding-top: 10px;
          padding-bottom: 10px;
          a{
            padding: 5px;
            border-radius: 5px;
            background-color: #00AE39;
            color: #fff;
            text-decoration: none;
          }
        }

        span{
          b{
            color: #00AE39;
          }
        }

      }
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/MillestonesSection.vue